import { AppThunk } from "../../../state/store"
import { setNotFirstPage } from "./navigationSlice"

export const initNavigation = (): AppThunk => async (dispatch) => {
  dispatch(setNotFirstPage())
}
